import { IState } from '../../store';

export const selectGalleryDIYBannerAnalyticsSent = (state: IState): boolean =>
  state.newbuildingBrokerDIY.galleryBannerAnalyticsSent;
